import React, { useContext, useEffect, useState } from 'react';
import SearchIcon from '../../../assests/img/search.svg?react';
import CloseIcon from '../../../assests/img/close-icon-grey.svg?react';
import {FilterContext} from '../context/filterContext';
import '../../../assests/css/search.scss';
import classNames from 'classnames';

export interface searchProps {
    onChange?: (text: string) => void,
    customClassName?: string,
}

export default function Search(props: searchProps) {
    const {customClassName, onChange} = props;

    const {filterContent, setFilterContent} = useContext(FilterContext);
    const [search, setSearch] = useState('');

    const handleSearchInput = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSearch(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    }

    const handleClearSearchInput = () => {
        setSearch('');
        if (onChange) {
            onChange('');
        }
    }

    useEffect(()=> {
        const setData = setTimeout(()=> {
            setFilterContent({...filterContent, search: search});
        }, 700)
        return ()=> clearTimeout(setData);
    }, [search])

    return (
        <div className={classNames('search-cotnainer', customClassName ? customClassName : '')}>
            <span className="search-icon">
                <SearchIcon width={"14"} height={"14"}/>
            </span>
            <input className="search-text" type="text" placeholder="Search"
                onChange={(e)=> handleSearchInput(e)} value={search}></input>
            {search ?
            <div onClick={handleClearSearchInput} style={{cursor: 'pointer'}}>
                <CloseIcon width={10} height={10}/>
            </div> : null}
        </div>
    );

}